<template>
  <div>
    <v-form autocomplete="new-password" ref="form" :lazy-validation="lazy">
      <v-text-field
        v-model="formData.name"
        label="Nome"
        name="name"
        prepend-icon="mdi-account"
        type="text"
        :rules="nameRules"
      />
      <v-text-field
        v-model="formData.email"
        label="Email"
        name="email"
        prepend-icon="mdi-email"
        type="text"
        :rules="emailRules"
        validate-on-blur
      />
      <v-text-field
        v-model="formData.password"
        id="password"
        label="Senha"
        name="password"
        prepend-icon="mdi-lock-open"
        type="password"
        :rules="[
          ruleRequired('Defina uma senha'),
          ruleMinLen(6),
          ruleMaxLen(10)
        ]"
      />
      <v-text-field
        v-model="formData.password_confirmation"
        id="password_confirmation"
        label="Confirmação de senha"
        name="password_confirmation"
        prepend-icon="mdi-lock"
        type="password"
        :rules="[
          ruleRequired('Confirme a senha'),
          ruleMinLen(6),
          ruleMaxLen(10),
          ruleMatch(formData.password)
        ]"
      />
    </v-form>
  </div>
</template>

<script>
import validations from "@/mixins/validations";
export default {
  props: {
    formData: {
      type: Object,
      required: true
    }
  },
  mixins: [validations],

  data() {
    return {
      lazy: false,
      valid: true
    };
  },
  methods: {
    validateForm() {
      return this.$refs.form.validate();
    }
  }
};
</script>
